import { post } from 'services/api';
import { ENV } from 'settings';

export const savePageLoad = (page: string, time: number) => () => {
  return post({
    url: '/healthcheck/page-load',
    data: {
      page,
      time,
      url: window.location.href,
      production: ENV === 'production',
    },
  });
};
